<template>
  <v-content>
    <v-container
      fill-height
      fluid>
      <v-layout
        align-center
        justify-center>
        <v-flex
          xs12
          sm8
          md4>
          <v-card
            style="color: rgb(75, 85, 99); padding: 20px"
            class="elevation-12">

            <div style="width: 100px; margin: 0 auto;">
              <v-img src="/img/logo.png"/>
            </div>
            <br>
            <v-card-text>
              <v-form>
                <v-text-field
                  ref="username"
                  v-model="username"
                  :rules="[() => !!username || 'This field is required']"
                  prepend-icon="mdi-account"
                  label="Email"
                  placeholder="Your email address"
                  required
                />
                <v-text-field
                  ref="password"
                  v-model="password"
                  :rules="[() => !!password || 'This field is required']"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  label="Password"
                  placeholder="*********"
                  counter
                  required
                  @keydown.enter="login"
                  @click:append="showPassword = !showPassword"
                />
                <v-checkbox
                  v-model="remember"
                  label="Remember me?"/>
              </v-form>
            </v-card-text>
            <v-divider class="mt-5"/>
            <v-card-actions>
              <v-spacer/>
              <a href="/forgot-password">
                Forgot your password?
              </a>
              &nbsp;
              &nbsp;
              <v-btn
                align-center
                justify-center
                color="general"
                @click="login">Login
              </v-btn>
            </v-card-actions>
            <v-snackbar
              v-model="snackbar"
              :color="color"
              :top="true"
            >
              {{ errorMessages }}
              <v-btn
                dark
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>
          </v-card>
        </v-flex>
      </v-layout>

    </v-container>
  </v-content>
</template>

<script>
export default {
  data: function () {
    return {
      username: '',
      password: '',
      remember: false,
      errorMessages: 'Incorrect login info',
      snackbar: false,
      color: 'general',
      showPassword: false
    }
  },

  // Sends action to Vuex that will log you in and redirect to the dash otherwise, error
  methods: {
    login: function () {
      let username = this.username
      let password = this.password
      let remember = this.remember
      this.$store.state.spinning = true
      this.$store.dispatch('login', { username, password, remember })
        .then(() => {
            var redirect = '/'
            let user = JSON.parse(localStorage.getItem('userInfo'))
            if (user.type === 'admin') {
                redirect = 'dashboard/dashboard'
            } else {
                redirect = 'dashboard/affiliate-profile'
            }
          setTimeout(() => {
            this.$router.push(redirect)
          }, 1000)

          this.$store.state.spinning = false
        })
        .catch(err => {
          console.log(err)
          this.snackbar = true
                  this.$store.state.spinning = false
                }
        )
    }
  },
  metaInfo () {
    return {
      title: 'Blah Blah Blah | Login'
    }
  }
}
</script>
